import React from 'react';
interface NavigationProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}
export function Navigation({
  activeTab,
  setActiveTab
}: NavigationProps) {
  const tabs = [{
    id: 'about',
    label: 'About Me'
  }, {
    id: 'portfolio',
    label: 'Work Portfolio'
  }, {
    id: 'resume',
    label: 'Resume'
  }, {
    id: 'contact',
    label: 'Contact'
  }];
  return <nav className="w-full bg-white shadow-sm sticky top-0 z-50" data-id="element-14">
      <div className="max-w-6xl mx-auto px-6" data-id="element-15">
        <div className="flex items-center justify-between h-16" data-id="element-16">
          <h1 className="text-xl font-bold text-gray-900" data-id="element-17">Jake Jackson</h1>
          <div className="flex space-x-1" data-id="element-18">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-4 py-2 rounded-md font-medium transition-colors ${activeTab === tab.id ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-19">
                {tab.label}
              </button>)}
          </div>
        </div>
      </div>
    </nav>;
}